import { Box, Checkbox, FormControlLabel, TextField, Typography } from '@mui/material';
import type { TestType } from '../../services/testService';

interface TestSelectionWithCountsProps {
  tests: TestType[];
  selectedTests: Set<string>;
  specimenCounts: Record<string, number>;
  onToggleTest: (testKey: string) => void;
  onCountChange: (testKey: string, count: number) => void;
  label?: string;
}

export const TestSelectionWithCounts = ({
  tests,
  selectedTests,
  specimenCounts,
  onToggleTest,
  onCountChange,
  label = 'Assign Tests',
}: TestSelectionWithCountsProps) => {
  return (
    <>
      <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1 }}>
        {label} ({selectedTests.size} selected)
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
        {tests.map((t) => {
          const isChecked = selectedTests.has(t.TestKey);
          const count = specimenCounts[t.TestKey] || 1;
          return (
            <Box key={t.TestKey} sx={{
              display: 'flex', alignItems: 'center', gap: 1, minHeight: 36,
            }}>
              <FormControlLabel
                control={
                  <Checkbox
                    size="small"
                    checked={isChecked}
                    onChange={() => onToggleTest(t.TestKey)}
                  />
                }
                label={t.TestName}
                sx={{ mr: 0, '& .MuiFormControlLabel-label': { fontSize: '0.85rem' } }}
              />
              {isChecked && (
                <TextField
                  size="small"
                  type="number"
                  label="# Tests"
                  value={count}
                  onChange={(e) => {
                    const v = Math.max(1, Math.min(20, Number(e.target.value) || 1));
                    onCountChange(t.TestKey, v);
                  }}
                  inputProps={{ min: 1, max: 20 }}
                  sx={{ width: 80, '& .MuiInputBase-input': { py: 0.5, fontSize: '0.8125rem' } }}
                />
              )}
            </Box>
          );
        })}
      </Box>
    </>
  );
};
